import { useParams } from "react-router-dom";

import UpdateUserForm from "../form/updatedUser/UpdateUserForm";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import spin from "../../../assets/icons/spin.png";
import { USER_SETUP, UPDATE_USER } from "../apiEndpoints";
import { GET_USER } from "../../../api/allApi_List";
import usePatchData from "../../../CustomHooks/useAxios/usePatchData";
import MainPageLayout from "../../../layout/MainPageLayout";
import useGetMultiple from "../../../CustomHooks/useAxios/useGetMultiple";

const UpdateUserPage = () => {
  const { id } = useParams();
  const { data, isLoaded, error } = useGetMultiple([GET_USER + id, USER_SETUP]);
  const { executePatch, loading, formError, successResponse, setFormError } =
    usePatchData();

  // execute post api
  const sendData = async (
    formValues,
    updateStateOnResponse,
    userExistingData,
  ) => {
    const formsData = {};
    Object.keys(formValues).forEach((key) => {
      const newValue = formValues[key];
      const existingValue = userExistingData[key];
      if (newValue !== existingValue) {
        formsData[key] = key === "salary" ? parseInt(newValue) : newValue;
      }
    });
    //API calling
    executePatch(formsData, UPDATE_USER + id, updateStateOnResponse);
  };
  return (
    <MainPageLayout headerConfig={{ title: "Update User" }}>
      {isLoaded && !error ? (
        <UpdateUserForm
          userSetup={data[1]}
          userData={data[0]}
          sendData={sendData}
          loading={loading}
          successResponse={successResponse}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};
export default UpdateUserPage;
